<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { trackButtonClick } from "../utils";
  import { userData } from "../store";
  import { deductCredits } from "../firebaseOperations";
  import GoogleSignIn from "../GoogleSignIn.svelte";
    import { user } from "firebase-functions/v1/auth";
  export let cloakLevel: number;
  export let inputText: string;

  let cloakLevelInfo = {
    text: "Regular Cloak",
    color: "green",
  };
  // detect change in cloakLevel
  $: cloakLevelInfo = getCloakLevelInfo(cloakLevel);

  // Function to return the appropriate info based on cloak level
  function getCloakLevelInfo(level) {
    switch (level) {
      case 1:
        return { text: "Light Cloak", color: "#50C878" };
      case 2:
        return { text: "Regular Cloak", color: "green" };
      case 3:
        return { text: "Deep Cloak", color: "red" };
      default:
        return { text: "Regular Cloak", color: "green" };
    }
  }
  function getHoverColor(color) {
  switch (color) {
    case "#50C878": // Light Cloak
      return "#3E9651"; // Slightly darker green
    case "green": // Regular Cloak
      return "#228B22"; // Forest green, slightly darker
    case "red": // Deep Cloak
      return "#CC0000"; // Darker red, not too deep
    default:
      return "#228B22"; // Default slightly darker green if something goes wrong
  }
}

  const ob = process.env.OBFUSCATE;
  // const ob = "http://localhost:3000/obfuscate";
  const dispatch = createEventDispatcher();
  let isLoading = false;
  let isSuccessful = false;
  let overlayText = "Cloak Strength";
  // Display the default slider value
  // Update the current slider value (each time you drag the slider handle)

  async function handleClick() {
    // make sure userdata isn't empty
    if($userData.id == undefined && cloakLevel == 2){
      document.getElementById('overlay-text').innerHTML = `<span style="color:green;">Regular</span> cloak requires a TextCloaker account!`;
      setTimeout(() => {
        document.getElementById('overlay-text').innerHTML = "Cloak Strength";
      }, 3000);
      return;
    }
    if(cloakLevel == 2 && $userData.credits == 0 && !$userData.premium){
      document.getElementById('overlay-text').innerHTML = `<span style="color:green;">Regular</span> cloak requires one (1) credit!`;
      setTimeout(() => {
        document.getElementById('overlay-text').innerHTML = "Cloak Strength";
      }, 3000);
      return;
    }
    if(!($userData.premium || $userData.admin) && cloakLevel == 3){
      document.getElementById('overlay-text').innerHTML = `<span style="color:red;">Deep</span> cloak requires TextCloaker <span class="shining-text">Premium</span>!`;
      setTimeout(() => {
        document.getElementById('overlay-text').innerHTML = `Cloak Strength`;
      }, 3000);

      return;
    }
    cloakLevelInfo = {
      text: "Loading...",
      color: "gray",
    };
    if ((!$userData.admin && !$userData.premium) && cloakLevel == 2) {
      const result = await deductCredits($userData.id, 1);
      if (result == 0) {
        $userData.credits -= 1;
      } else {
        if (result == 1) {
          overlayText = "Insufficient Credits";
          document.getElementById("obfuscate").classList.add("grey-overlay");
        } else if (result == 2) {
          overlayText = "User does not exist!";
          document.getElementById("obfuscate").classList.add("grey-overlay");
        } else if (result == 3) {
          overlayText = "Transaction error!";
          document.getElementById("obfuscate").classList.add("grey-overlay");
        }
        setTimeout(() => {
          overlayText = "Cost: 1 Credit";
        }, 2000);

        if (cloakLevel == 1) {
          cloakLevelInfo = {
            text: "Light Cloak",
            color: "#50C878",
          };
        }
        if (cloakLevel == 2) {
          cloakLevelInfo = {
            text: "Regular Cloak",
            color: "green",
          };
        }
        if (cloakLevel == 3) {
          cloakLevelInfo = {
            text: "Deep Cloak",
            color: "red",
          };
        }
        return;
      }
    }
    await new Promise((r) => setTimeout(r, 1000));
    trackButtonClick("Obfuscate", cloakLevel);
    obfuscate();
  }
  async function obfuscate() {
    isSuccessful = false;
    isLoading = true;

    const obfuscateAsync = async () => {
      try {
        const response = await fetch(ob, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: $userData.id,
            inputs: inputText,
            strength: cloakLevel,
          }),
        });

        if (!response.ok) {
          throw new Error("Request failed");
        }

        const data = await response.json();
        const responseData = data.modifiedData;
        let mobile = false;
        try {
          await navigator.clipboard.writeText(responseData);
        } catch (error) {
          mobile = true;
        }
        if (mobile) {
          try {
            await window.Toaster.postMessage(responseData);
          } catch (error) {
            console.error(error);
          }
        }
        dispatch("success", responseData);
        isSuccessful = true;
        cloakLevelInfo = {
          text: "Success!",
          color: "green",
        };

        setTimeout(() => {
          if (cloakLevel == 1) {
            cloakLevelInfo = {
              text: "Light Cloak",
              color: "#50C878",
            };
          }
          if (cloakLevel == 2) {
            cloakLevelInfo = {
              text: "Regular Cloak",
              color: "green",
            };
          }
          if (cloakLevel == 3) {
            cloakLevelInfo = {
              text: "Deep Cloak",
              color: "red",
            };
          }
        }, 2000);
      } catch (error) {
        console.error(error);
        if (cloakLevel == 1) {
          cloakLevelInfo = {
            text: "Light Cloak",
            color: "#50C878",
          };
        }
        if (cloakLevel == 2) {
          cloakLevelInfo = {
            text: "Regular Cloak",
            color: "green",
          };
        }
        if (cloakLevel == 3) {
          cloakLevelInfo = {
            text: "Deep Cloak",
            color: "red",
          };
        }
      }

      setTimeout(() => {
        isSuccessful = true;
        isLoading = false;
        setTimeout(() => {
          isSuccessful = false;
        }, 3000);
      }, 100);
    };

    setTimeout(obfuscateAsync, 1000);
  }
  $: hoverColor = getHoverColor(cloakLevelInfo.color);
  $: cloakLevelInfo = getCloakLevelInfo(cloakLevel);
</script>

<div class="action-container">
  <div class="button-container">
    <button
      id="obfuscate"
      on:click={handleClick}
      class="button obfuscate-button"
      style="background-color: {cloakLevelInfo.color};"
      on:mouseover="{() => cloakLevelInfo.color = hoverColor}"
      on:mouseout="{() => cloakLevelInfo.color = getCloakLevelInfo(cloakLevel).color}"
    >
      {cloakLevelInfo.text}
    </button>
  </div>

  <div class="slider-container">
    <input
      type="range"
      min="1"
      max="3"
      bind:value={cloakLevel}
      class="slider"
      id="cloakLevel"
    />
    <div class="overlay-text" id="overlay-text" style="font-weight: bold;">
      {overlayText}
    </div>
  </div>
  <br>
  <div id="signIn" style="top: -2rem">
    <p>Sign in to access regular level cloaking!</p>
    <GoogleSignIn />
  </div>
</div>

<style>
#obfuscate {
  font-size: 1.2rem;
  border: none;
  border-radius: 5px;
  color: white;
  transition: background-color 0.3s ease; /* Ensures the color changes smoothly */
}
  .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 0.5rem; /* Increased height */
    background: linear-gradient(to right, #50C878 33%, green 33% 66%, red 66%);
    outline: 1px solid transparent; /* Remove the outline */
    opacity: 0.7;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;
  }

  .button-container {
    margin-bottom: 0.5rem;
  }

  .slider-container {
    position: relative; /* Set to relative */
    margin-top: 1rem; /* More space above the slider */
    padding-bottom: 1rem;
    width: 100%;
    text-wrap: wrap;
  }

  .overlay-text {
    position: absolute; /* Positioned absolutely */
    bottom: -2.5rem;

    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: medium;
    text-wrap: wrap;

  }
  /* Action Container */
  .action-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%; /* Limit the width for better focus */
    max-width: 100%;
    justify-content: center;
    margin: auto; /* Center align */
    padding: 2rem 1rem;
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3); /* Subtle shadow for emphasis */
    border-radius: 10px;
  }

  .slider:hover {
    opacity: 1;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 1rem;
    height: 1rem;
    background: rgb(43, 43, 40);
    cursor: pointer;
  }

  .slider::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background: rgb(43, 43, 40);
    cursor: pointer;
  }
  p {
    font-size: small;
  }
</style>
